'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowUp = function TiArrowUp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.7 9.3l-7.9 7.9c-0.6 0.6-0.6 1.7 0 2.3s1.7 0.7 2.4 0l3.8-3.8v12.6c0 1 0.7 1.7 1.7 1.7s1.6-0.7 1.6-1.7v-12.6l3.9 3.8c0.3 0.3 0.7 0.5 1.1 0.5s0.9-0.2 1.2-0.5c0.7-0.6 0.7-1.7 0-2.3l-7.8-7.9z' })
        )
    );
};

exports.default = TiArrowUp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-up.js
// module id = 3751
// module chunks = 0